import { render, staticRenderFns } from "./TaxDocumentSubmission.vue?vue&type=template&id=2da7f178&scoped=true"
import script from "./TaxDocumentSubmission.vue?vue&type=script&lang=js"
export * from "./TaxDocumentSubmission.vue?vue&type=script&lang=js"
import style0 from "./TaxDocumentSubmission.vue?vue&type=style&index=0&id=2da7f178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7f178",
  null
  
)

export default component.exports